import { HighlightStyle, StreamLanguage, type StreamParser, type StringStream } from "@codemirror/language";
import { tags } from "@lezer/highlight";

export const LUNASCRIPT_LANGUAGE = {
  directive: /^[@&][A-Za-z_][\w.-]*$/,
  speaker: /^[A-Z][A-Z0-9_-]*(?:\s+\[[^\]]+\])?\s*:/,
  comment: /^\s*\/\//,
  branchKey: /\b(?:main|route|ending|bonus)(?:[/:][\w.-]+)+\b/,
} as const;

const parser: StreamParser<Record<string, never>> = {
  name: "lunascript",
  startState: () => ({}),
  languageData: { commentTokens: { line: "//" }, closeBrackets: { brackets: ["(", "[", "{", "\""] }, indentOnInput: /^\s*[}\]]$/ },
  token(stream: StringStream): string | null {
    if (stream.eatSpace()) return null;
    if (stream.match(/\/\/.*/)) return "comment";
    if (stream.match(/[@&][A-Za-z_][\w.-]*/)) return "keyword";
    if (stream.match(/"(?:[^"\\]|\\.)*"/)) return "string";
    if (stream.match(/[A-Z][A-Z0-9_-]*(?=\s*(?:\[[^\]]+\])?:)/)) return "variableName.constant";
    if (stream.match(/\[[^\]]+\]/)) return "typeName";
    if (stream.match(/\b(?:brave|safe|check\.success|check\.fail|true|false|null)\b/)) return "bool";
    if (stream.match(/\b(?:main|route|ending|bonus)(?:[/:][\w.-]+)+\b/)) return "labelName";
    if (stream.match(/[+-]?\d+(?:\.\d+)?/)) return "number";
    if (stream.match(/[{}()[\]:,]/)) return "punctuation";
    if (stream.match(/(?:>=|<=|==|!=|&&|\|\||[=+\-<>])/)) return "operator";
    stream.next();
    return null;
  },
};

export const lunascript = StreamLanguage.define(parser);

export const lunascriptHighlightStyle = HighlightStyle.define([
  { tag: tags.keyword, class: "cm-ls-keyword" },
  { tag: tags.comment, class: "cm-ls-comment" },
  { tag: tags.string, class: "cm-ls-string" },
  { tag: tags.constant(tags.variableName), class: "cm-ls-speaker" },
  { tag: tags.typeName, class: "cm-ls-look" },
  { tag: tags.bool, class: "cm-ls-bool" },
  { tag: tags.labelName, class: "cm-ls-route" },
  { tag: tags.number, class: "cm-ls-number" },
  { tag: tags.operator, class: "cm-ls-operator" },
  { tag: tags.punctuation, class: "cm-ls-punctuation" },
]);
